var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-play.872b875f.png","uri@2x": __webpack_public_path__ + "icon-play.e9ae1151.png","uri@3x": __webpack_public_path__ + "icon-play.83e06763.png",
    width: 48,
    height: 48
});